import type { ObjectSelectValue } from "@components/ObjectSelect";
import type { AdminUser, DirectoryUserObject } from "@features/users/api";

export type FormValues = Pick<
  AdminUser,
  | "id"
  | "last_name"
  | "first_name"
  | "middle_name"
  | "company"
  | "city"
  | "address"
  | "note"
  | "status"
  | "role"
> & {
  email?: string;
  phone?: string;
  objects?: ObjectSelectValue[];
};

export const normalizeObjects = (objects?: DirectoryUserObject[]): ObjectSelectValue[] =>
  (objects ?? []).map((link) => ({
    regionId: link.region_id,
    objectId: link.object_id,
  }));

export const generateLogin = () =>
  globalThis.crypto?.randomUUID?.() ?? `user-${Math.random().toString(36).slice(2, 10)}`;

export const preparePayload = (
  values: FormValues,
  fallbackId: string,
  existing?: AdminUser,
): AdminUser => {
  const contacts = [];
  if (values.email?.trim()) {
    contacts.push({ type: "email", value: values.email.trim(), is_primary: true });
  }
  if (values.phone?.trim()) {
    contacts.push({ type: "phone", value: values.phone.trim(), is_primary: true });
  }
  const objects: DirectoryUserObject[] = (values.objects ?? [])
    .filter((item): item is ObjectSelectValue => Boolean(item?.regionId && item?.objectId))
    .map((item) => ({
      region_id: item.regionId,
      object_id: item.objectId,
    }));
  const status = values.status ?? existing?.status ?? "pending";
  const role = values.role ?? existing?.role ?? "user";
  return {
    id: values.id?.trim() || fallbackId,
    last_name: values.last_name?.trim() || undefined,
    first_name: values.first_name?.trim() || undefined,
    middle_name: values.middle_name?.trim() || undefined,
    company: values.company?.trim() || undefined,
    city: values.city?.trim() || undefined,
    address: values.address?.trim() || undefined,
    note: values.note?.trim() || undefined,
    status,
    is_active: status === "active",
    role,
    contacts,
    objects,
    telegram_id: existing?.telegram_id,
    telegram_username: existing?.telegram_username,
  };
};
